import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import useRoles from 'common/hooks/useRoles';
import { deletePatientMedication } from 'store/thunks/patientThunks';
import useInfoDialog from 'common/hooks/useInfoDialog';

import EditMedicationDialog from './EditMedicationDialog';

const PatientMedicationOptions = ({ mpi, patientMedicationId }) => {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { InfoDialog, showInfoDialog } = useInfoDialog();
  const menuOpen = !!anchorEl;
  const dispatch = useDispatch();
  const hasAccess = useRoles();

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleShowEditDialog = () => {
    setShowEditDialog(true);
    handleMenuClose();
  };

  const handleDeletePatientMedication = () => {
    handleMenuClose();
    showInfoDialog({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this medication?',
      callback: () => dispatch(deletePatientMedication({ mpi, patientMedicationId })),
      cancelable: true,
      isWarning: true,
      confirmButtonText: 'Confirm',
    });
  };

  const handleCloseEditDialog = () => setShowEditDialog(false);

  return (
    <>
      <InfoDialog />
      <EditMedicationDialog
        mpi={mpi}
        patientMedicationId={patientMedicationId}
        open={showEditDialog}
        onClose={handleCloseEditDialog}
      />

      <IconButton
        id={`PatientView-PatientMedicationOptions-${patientMedicationId}options-button`}
        aria-label={`Medication options ${patientMedicationId}`}
        aria-controls={
          menuOpen
            ? `PatientView-PatientMedicationOptions-${patientMedicationId}options-menu`
            : undefined
        }
        aria-haspopup='true'
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleMenuOpen}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id={`PatientView-PatientMedicationOptions-${patientMedicationId}options-menu`}
        aria-labelledby={`PatientView-PatientMedicationOptions-${patientMedicationId}options-button`}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleShowEditDialog} disabled={!hasAccess.updateMedication}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDeletePatientMedication} disabled={!hasAccess.deleteMedication}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

PatientMedicationOptions.propTypes = {
  patientMedicationId: PropTypes.string.isRequired,
  mpi: PropTypes.string.isRequired,
};

export default PatientMedicationOptions;
